import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";

import { SliceKeys, tablePaginationInitialValue } from "@sso/constant";
import { RootState } from "@sso/store";
import { SearchColumn, SortKeys } from "@sso/types";
import { getTableSortColumn, queryBuilder } from "@sso/utils";

export const OrderSlice = createSlice({
  name: SliceKeys.ORDER,
  initialState: {
    pagination: { ...tablePaginationInitialValue, sort: { column: "CreatedDate", type: SortKeys.DESC } },
  },
  reducers: {
    setOrderPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
      state.pagination.pageSize = action.payload;
    },
    setOrderPageIndex: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = action.payload;
    },
    setOrderSearchColumn: (state, action: PayloadAction<SearchColumn>) => {
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
      state.pagination.search[action.payload.column] = action.payload;
    },
    clearOrderSearchColumn: (state, action: PayloadAction<string>) => {
      const { [action.payload]: deleteItem, ...otherSearchItems } = state.pagination.search;
      state.pagination.search = otherSearchItems;
    },
    setOrderSortColumn: (state, action: PayloadAction<{ column: string; multiField?: string[] }>) => {
      const { column, type } = state.pagination.sort;
      state.pagination.sort = getTableSortColumn(column, action.payload.column, type, action.payload.multiField);
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
    },
  },
});

export const { setOrderPageSize, setOrderPageIndex, setOrderSortColumn, setOrderSearchColumn, clearOrderSearchColumn } =
  OrderSlice.actions;

export const selectOrderPagination = createSelector(
  (state: RootState) => state.order.pagination,
  ({ pageSize, totalPages, pageIndex, sort, search }) => ({
    pageSize: { action: setOrderPageSize, value: pageSize },
    pagination: {
      totalPages,
      pageIndex,
      action: setOrderPageIndex,
    },
    sort,
    search: { object: search, onChange: setOrderSearchColumn, onClear: clearOrderSearchColumn },
  }),
);

export const selectOrderQuery = createSelector(
  (state: RootState) => state.order.pagination,
  ({ pageSize, pageIndex, search, sort }) => queryBuilder(pageSize, pageIndex, search, sort),
);

export default OrderSlice.reducer;
